import ButtonBase from '@material-ui/core/ButtonBase';
import clsx from 'clsx';
import { memo, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { ImageFallbackProductImage } from 'utils/ImageFallback';
import { getLinkCDNVideo } from 'utils/ImageUtils';
import { checkVideoUrl } from 'utils/video';
import useDetailPriceStates, { useDetailPriceActions } from 'zustand-lib/useProductDetailPrices';
import styles from './styles.module.css';

const ImageSlider = ({ images, imageActive, setImageActive, onClickImage, isOpenModal, className, alt = '' }) => {
  const { updateFirstTimeAccessPDP } = useDetailPriceActions();
  const { isFirstTimeAccessPDP = false } = useDetailPriceStates();
  let refInstance = useRef(null);
  const handleActiveImage = (index) => {
    setImageActive(index);
    if (isFirstTimeAccessPDP) updateFirstTimeAccessPDP();
  };
  const handleOpenModal = (index) => {
    onClickImage(index);
    if (isFirstTimeAccessPDP) updateFirstTimeAccessPDP();
  };
  const ImageItem = ({ url, index }) => (
    <div
      className={clsx(styles.imageItem, index === imageActive && styles.active)}
      onClick={() => handleOpenModal(index)}
      onMouseEnter={() => handleActiveImage(index)}
    >
      <ImageFallbackProductImage size="thumbnail" width={60} height={60} src={url} alt={alt} />
    </div>
  );

  const VideoItem = ({ url, index }) => {
    return (
      <div
        className={clsx(styles.imageItem, index === imageActive && styles.active)}
        onClick={() => handleOpenModal(index)}
        onMouseEnter={() => handleActiveImage(index)}
      >
        <video src={getLinkCDNVideo(url)} width="50px" height="50px" objectfit="contain" className={'h-[50px]'} />
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  // useEffect(() => {
  //   if (isOpenModal && images.length > 2) {
  //     if (imageActive === 0) {
  //       refInstance?.slickGoTo(0);
  //     } else if (imageActive > 2) {
  //       refInstance?.slickGoTo(imageActive - 2);
  //     }
  //   }
  // }, [isOpenModal, imageActive]);
  const next = () => refInstance.slickNext();

  const previous = () => refInstance.slickPrev();
  return (
    <div className={clsx(styles.sliderContainer, images.length <= 3 && styles.lessThenThree, className)}>
      {images.length > 3 ? (
        <div className={styles.wrapperSlider}>
          <div className={styles.wrapperRight} onClick={next} role="button" aria-label="next image">
            <i className={`${styles.arrow} ${styles.right}`} />
          </div>
          <Slider
            // eslint-disable-next-line no-return-assign
            ref={(c) => (refInstance = c)}
            {...settings}
            className={styles.slider}
          >
            {images.map((url, index) => (
              <ButtonBase key={url} onClick={() => handleOpenModal(index)} className="openImg">
                {checkVideoUrl(url) ? <VideoItem key={url} url={url} index={index} /> : <ImageItem key={url} url={url} index={index} />}
              </ButtonBase>
            ))}
          </Slider>
          <div className={styles.wrapperLeft} onClick={previous} role="button" aria-label="prev image">
            <i className={`${styles.arrow} ${styles.left}`} onClick={previous} />
          </div>
        </div>
      ) : (
        <>
          {images.map((url, index) => (
            <div key={index}>{checkVideoUrl(url) ? <VideoItem url={url} index={index} /> : <ImageItem url={url} index={index} />}</div>
          ))}
        </>
      )}
    </div>
  );
};

export default memo(ImageSlider);
